import { useApi, useAuth } from '../../hooks';
import { useQuery } from '@tanstack/react-query';
import { LabOption } from '../types';

// Healthie's labOptions query is search-string driven; match the backend's
// 3-character minimum so we don't fire a request per keystroke.
export const MIN_LAB_OPTION_SEARCH = 3;

export const useLabOptions = (search: string, labName: string) => {
  const { api } = useApi({ throwIfError: true });
  const { isAuthenticated, loading, userToken } = useAuth();

  const fetchLabOptions = async () => {
    const requestObj = {
      route: `/private/dashboard/lab-options?search=${encodeURIComponent(
        search
      )}&lab_name=${encodeURIComponent(labName)}`,
      token: userToken,
    };

    return api(requestObj);
  };

  const enabled =
    isAuthenticated &&
    !loading &&
    !!userToken &&
    search.length >= MIN_LAB_OPTION_SEARCH;

  const { data, isLoading, isError } = useQuery<LabOption[], Error>(
    ['lab-options', search, labName],
    fetchLabOptions,
    {
      enabled,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      // Type-ahead search: fail fast instead of the default 3 retries, so the
      // error surfaces quickly and we don't re-hit Healthie on every keystroke.
      retry: 1,
    }
  );

  return {
    labOptions: data ?? [],
    isLoading,
    isError,
  };
};
